import { LuArrowRight } from "react-icons/lu";
import {
  ButtonGroup,
  Container,
  Description,
  Disclaimer,
  Section,
  StyledButton,
  Title
} from "./styles";
import Link from "next/link";
import { track } from "@/lib/analytics/track";

export default function CTA() {
  return (
    <Section id="contato">
      <Container>
        <Title>Pronto para transformar sua clínica odontológica?</Title>
        <Description>
          Junte-se a milhares de profissionais que já otimizaram seus processos
          e melhoraram a experiência de seus pacientes com o DentalMap.
        </Description>

        <ButtonGroup>
          <Link
            href={`https://wa.me/5538999568521?text=${encodeURIComponent(
              "Olá! Gostaria de solicitar uma demonstração do DentalMap."
            )}`}
            target="_blank"
            onClick={() =>
              track({ event: "whatsapp_cta_clicked", cta_type: "demo" })
            }
          >
            <StyledButton className="primary">
              Solicitar Demonstração <LuArrowRight size={18} />
            </StyledButton>
          </Link>
          <Link
            href={`https://wa.me/5538999568521?text=${encodeURIComponent(
              "Olá! Gostaria de falar com um consultor sobre o DentalMap."
            )}`}
            target="_blank"
            onClick={() =>
              track({ event: "whatsapp_cta_clicked", cta_type: "consultor" })
            }
          >
            <StyledButton className="outline">Falar com Consultor</StyledButton>
          </Link>
        </ButtonGroup>

        <Disclaimer>
          Não é necessário cartão de crédito. Teste gratuito por 14 dias.
        </Disclaimer>
      </Container>
    </Section>
  );
}
